import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { TeambookIcon } from "../default_images/TeambookIcon";
import { icons } from "../default_images/IconsList";
import TeambookBlueButton from "./TeambookBlueButton";
import TeambookWhiteButton from "./TeambookWhiteButton";
import TeambookOutlinedButton from "./TeambookOutlinedButton";
import TeambookRedButton from "./TeambookRedButton";
import PropTypes from "prop-types";

const TeambookDialog = ({
  htmlTitle,
  open,
  onClose,
  title,
  withCloseButton = false,
  content,
  actionButtons = [],
  size = "default",
  dialogClassName = "",
  ...props
}) => {
  const parsedButton = (button, index) => {
    if (button.customButton) return button.customButton;

    const ButtonComponent = {
      red: TeambookRedButton,
      outlined: TeambookOutlinedButton,
      white: TeambookWhiteButton,
      blue: TeambookBlueButton,
    }[button.type || "blue"];

    return (
      <ButtonComponent
        key={index}
        text={button.text}
        onClick={button.onClick}
        id={button.id}
        disabled={button.disabled}
      />
    );
  };

  return (
    <Dialog
      className={`tb-default-dialog ${dialogClassName}`}
      data-size={size}
      open={open}
      onClose={onClose}
      {...props}
    >
      {title && (
        <DialogTitle>
          <p>{title}</p>

          {withCloseButton && <TeambookIcon name={icons.CROSS} onClick={onClose} />}
        </DialogTitle>
      )}

      {htmlTitle && (
        <DialogTitle>
          {htmlTitle}

          {withCloseButton && <TeambookIcon name={icons.CROSS} onClick={onClose} />}
        </DialogTitle>
      )}

      <DialogContent>{content}</DialogContent>

      {actionButtons.length > 0 && (
        <DialogActions>{actionButtons.map((button, index) => parsedButton(button, index))}</DialogActions>
      )}
    </Dialog>
  );
};

TeambookDialog.propTypes = {
  htmlTitle: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string,
  withCloseButton: PropTypes.bool,
  content: PropTypes.node.isRequired,
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
      type: PropTypes.oneOf(["red", "outlined", "white", "blue"]),
      id: PropTypes.string,
      disabled: PropTypes.bool,
      htmlText: PropTypes.node,
    })
  ),
  size: PropTypes.oneOf(["default", "small", "large"]),
  dialogClassName: PropTypes.string,
};

export default TeambookDialog;
